<template>
  <div class="container">
    <div class="retreat">
      <Card>
          <p slot="title">订单详情</p>
          <Row style="margin-bottom:5px">
            <Col span="10">
              <span class="order-detail-space">订单编号:</span> <span class="gary">{{data.sn}}</span>
            </Col>
            <Col span="10">
              <span class="order-detail-space">状  态:</span> <span v-if="data.status == '0'" class="waiting">{{data.statusName}}</span>
              <span v-if="data.status == '1'" class="already">{{data.statusName}}</span>
              <span v-if="data.status == '2'" class="completed">{{data.statusName}}</span>
              <span v-if="data.status == '3'" class="cancelled">{{data.statusName}}</span>
              <span v-if="data.status == '4'" class="closed">{{data.statusName}}</span>
            </Col>
            <Col span="4">
              <Button type="primary" style="margin-right:5px;border-radius:15px;width:70px" v-show="data.statusName === '已预约' && data.orderInfoItemList[0].ticketStatus === '2'" @click="allRefund(data)">退票</Button>
            </Col>
          </Row>
          <Row style="margin-bottom:10px">
            <Col span="10">
              <span class="order-detail-space">订 单 ID:</span> <span class="gary">{{data.id}}</span>
            </Col>
            <!-- <Col span="10">
              <span class="order-detail-space">类  型:</span> <span class="gary">{{data.orderSourceName}}订单</span>
            </Col> -->
            <Col span="10">
              <span class="order-detail-space">门票数量:</span> <span class="gary">{{data.playCount}}</span>
            </Col>
          </Row>
          <Row style="margin-bottom:10px">
            <Col span="10">
              <span class="order-detail-space">总 金 额:</span> <span class="gary">￥{{data.totalPrice}}</span>
            </Col>
            <Col span="10">
              <span class="order-detail-space">创建日期:</span> <span class="gary">{{data.createTime | formatTime('yyyy-MM-dd')}}</span>
            </Col>
          </Row>
      </Card>
    </div>

    <div class="space">
      <Card>
        <p slot="title">门票详情</p>
        <a @click="handleToggleSearch" slot="extra">{{ toggleSearchStatus ? '收起' : '展开全部' }}
          <Icon :type="toggleSearchStatus ? 'ios-arrow-up' : 'ios-arrow-down'"/>
        </a>
        <div class="ticket-info" v-show="toggleSearchStatus">
          <div class="ticket-item">
              <div class="detail-title">
                <div class="displayName">{{groupDetail.ticketName}}{{data.canLecturer ? '(含讲解)':''}}</div>
                <!-- <div v-if="item.ticketStatus == 0" class="wait-ticket">{{item.ticketStatusName}}</div>
                <div v-if="item.ticketStatus == 1" class="not-active">{{item.ticketStatusName}}</div>
                <div v-if="item.ticketStatus == 2" class="unused">{{item.ticketStatusName}}</div>
                <div v-if="item.ticketStatus == 3" class="part-used">{{item.ticketStatusName}}</div>
                <div v-if="item.ticketStatus == 4" class="already-used">{{item.ticketStatusName}}</div>
                <div v-if="item.ticketStatus == 5" class="refunded">{{item.ticketStatusName}}</div> -->
                <div v-if="groupDetail.ticketStatus == 0" class="wait-ticket">待出票</div>
                <div v-if="groupDetail.ticketStatus == 1" class="not-active">未激活</div>
                <div v-if="groupDetail.ticketStatus == 2" class="unused">未使用</div>
                <div v-if="groupDetail.ticketStatus == 3" class="part-used">部分使用</div>
                <div v-if="groupDetail.ticketStatus == 4" class="already-used">已使用</div>
                <div v-if="groupDetail.ticketStatus == 5" class="refunded">已退票</div>
              </div>
              <div class="info-item">
                <div class="info-img" v-if="groupDetail.mediaType == 'traveller_cert' && groupDetail.cerType == 'id_card'">
                    <img src="img/idCard.png" width="100%" height="70px"/>
                  </div>
                  <div class="info-img" v-if="groupDetail.mediaType == 'traveller_cert' && groupDetail.cerType == 'hkmo_id_card'">
                    <img src="img/hkmo.png" width="100%" height="120px"/>
                  </div>
                  <div class="info-img" v-if="groupDetail.mediaType == 'traveller_cert' && groupDetail.cerType == 'passport'">
                    <img src="img/passport.png" width="100%" height="120px"/>
                  </div>
                <div class="info-detail">
                      <div class="detail"><span class="ticket-detail-space">游玩日期:</span> <span class="gary">{{groupDetail.playDate}}</span></div>
                      <div class="detail"><span class="ticket-detail-space">验票时段:</span> <span class="gary">{{groupDetail.playPeriodStartTime?groupDetail.playPeriodStartTime.substring(11,19):'-'}}~{{groupDetail.playPeriodEndTime?groupDetail.playPeriodEndTime.substring(11,19):'-'}}</span></div>
                  </div>
              </div>
              <div style="display:flex;flex-direction:column;align-items:center">
                <div v-for="item in groupDetail.orderItemAttrs" style="display:flex">
                   <div>游览人:</div>
                  <div style="width:120px;padding:0 10px;text-align:center">{{item.name}}</div>
                  <div>{{item.cerNo}}</div>
                </div>
              </div>
              <div class="refund-notice">请持身份证原件验证入园，可供{{groupDetail.playCount}}人使用</div>
              <div class="explain" v-if="data.canLecturer">
                <div class="explain-notice">请于{{groupExplainDetail.playPeriodStartTime?groupExplainDetail.playPeriodStartTime.substring(11,19):'-'}}之前联系讲解员，并出示以下二维码</div>
                <div style="display:flex;width:240px;justify-content:space-around;padding:20px">
                  <div style="width:34px;padding:10px;background:black;color:white;text-align:center">讲解凭证</div>
                  <div style="display:flex;flex-direction: column;">
                    <div :id="groupExplainDetail.id" :title="title"></div>
                  </div>
                </div>
                <div v-if="groupDetail.ticketStatus == 0" style="text-align:center">待出票</div>
                <div v-if="groupDetail.ticketStatus == 1" style="text-align:center">未激活</div>
                <div v-if="groupDetail.ticketStatus == 2" style="text-align:center">未使用</div>
                <div v-if="groupDetail.ticketStatus == 3" style="text-align:center">部分使用</div>
                <div v-if="groupDetail.ticketStatus == 4" style="text-align:center">已使用</div>
                <div v-if="groupDetail.ticketStatus == 5" style="text-align:center">已退票</div>
              </div>
          </div>
        </div>
      </Card>
    </div>

    <div class="space">
      <Card>
        <p slot="title">使用说明</p>
        <div>
          <div class="common-icon-title">
            <h4>门票使用</h4>
            <div class="common-ticket-border">证件票</div>
          </div>
          <p>使用二代身份证原件购票的，可持身份证原件验证件入园</p>
        </div>
        <div>
        <div class="xs-qrcode-produce">
          <div>
            <img src="../../../assets/xs-qrcode-produce.jpg" width="100px"/>
          </div>
          <div>请扫码关注香山公众号，并在个人购票记录中查找我的门票</div>
        </div>
         <div class="common-icon-title">
            <h4>退票政策</h4>
            <div class="common-ticket-border">未使用可退</div>
          </div>
          <p>未使用的门票在游玩日期之前可随时退票</p>
        </div>
      </Card>
    </div>

  </div>
</template>

<script>
import { httpAction } from '@/api/manage'
import QRCode from 'qrcodejs2'
import api from "@/api";
export default {
  name:'MyBookOrderDetail',
  data () {
    return {
      title: null,
      data: [],
      groupDetail:{},
      groupExplainDetail:{},
      // showMore:true,
      // showHide:false,
      toggleSearchStatus: true
    }
  },
  filters: {
    // 格式化时间
    formatTime: function (date1, fmt) {
      // var date = new Date(date1)
      // 处理ie10 时间显示NaN问题
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Chrome") > -1){
        var date = new Date(date1)
      }else{
        var date = new Date(Date.parse(date1.replace(/-/g, "/")))
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          var str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
      }
      return fmt
    }
  },
  // 此处用created无问题,用mounted的话属性计算没完成就进行了渲染导致playCount,canInvoice,canRefund为空。
  created () {
    this.getOrderDetail({
      id:this.$route.query.id,
      sn:this.$route.query.sn,
    })
  },
  methods: {
    // 订单详情是否展开
    handleToggleSearch () {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    // 生成二维码
    creatQrCode (id, encTicketNo, bgColor) {
      this.$nextTick(() => {
        // eslint-disable-next-line no-new
        if (document.getElementById(id)) {
          // eslint-disable-next-line no-new
          // console.log(encTicketNo)
          new QRCode(document.getElementById(id), { text: encTicketNo, width: 128, height: 128, colorLight: bgColor })
        }
      })
    },
    // 查询订单详细
    async getOrderDetail (param) {
      const res = await httpAction(api.customMadeOrder, 'post', param);
      this.data = res.data;
      if(res.data.orderInfoItemList.length > 1){
        this.groupDetail = res.data.orderInfoItemList[0]
        this.groupExplainDetail = res.data.orderInfoItemList[1]
        let bgColor = ''
        if (this.groupExplainDetail.ticketStatus === '5') {
          bgColor = '#666'
        } else {
          bgColor = '#fff'
        }
        this.creatQrCode(this.groupExplainDetail.id, this.groupExplainDetail.encTicketNo, bgColor)
      }else{
        this.groupDetail = res.data.orderInfoItemList[0]
      }
      // console.log(this.groupDetail)
      

    },
    // 退票
    allRefund (data) {
      const userId = data.userId;
      const orderId = data.id;
      // const orderItemId = data.orderInfoItemList.filter(item => item.ticketName !== '团队讲解预约')[0].id;
      let orderItemId = data.orderInfoItemList.map(item => item.id)
      if(orderItemId.length === 1) {
        orderItemId = orderItemId[0]
      }
      // console.log(orderItemId)
      this.$Modal.confirm({
        title: '是否确认退票',
        onOk: async () => {
          const res = await httpAction(api.refundTicket, 'post', {
              "version": "1",
              "appCode": "sqbs46v3",
              "parkId": "1",
              "userId": userId,
              "orderId": orderId,
              "orderItemId": orderItemId
          })
          if (res.status === '0') {
            this.$Message.success('正在退票,请耐心等待');
            if(document.getElementById(orderItemId[1])){
              document.getElementById(orderItemId[1]).removeChild()
            }
            this.getOrderDetail({
              id:this.$route.query.id,
              sn:this.$route.query.sn,
            })
          } else {
            this.$Message.error(res.errorMessage)
          }
        },
        onCancel: () => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
.container{
  background-color: @container;
  margin: 20px 0;
}
.title{
  width: 15%;
  padding:20px;
}
.space{
  margin-top:5px
}

.ticket-info{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.ticket-item{
  position: relative;
  width: 48%;
  margin-bottom: 30px;
  /* height: 300px; */
  padding:20px;
  border: 1px solid #f5f7f9;
  box-shadow: 2px 2px 5px #aca9a9;
  -moz-box-shadow: 2px 2px 5px #aca9a9;
  -webkit-box-shadow: 2px 2px 5px #aca9a9;
  .info-item{
    min-height: 124px;
  }
}
.info-item{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.info-img{
  width: 25%;
  position: relative;
}
.ticket-tips{
  position: absolute;
  right: 0px;
  top: 50px;
  width: 72px;
  line-height: 1;
  height: 24px;
  // border-radius: 15px;
  color: #fff;
  font-weight: 600;
  font-size: 24px;
  transform: rotateZ(0deg);
  z-index: 1000;
}
.info-detail{
  width: 50%;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}
.detail-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.detail{
  margin-bottom: 5px;
}
.detail-btn{
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-top: 10px;
}
.notice{
  // position: relative;
  text-align: center;
  margin-top:10px;
  color:#999999;
}
.refund-btn{
  // position: absolute;
  // right: 0px;
  // bottom:0px;
  text-align: right;
}
.common-icon-title{
  display: flex;
  margin-top: 5px;
  margin-bottom: 10px;
}
.common-ticket-border{
   margin-left: 5px;
  border:1px solid #ED7457;
  background:#FFEAE2;
  border-radius: 8px;
  font-size: 12px;
  color: #ED7457;
  padding: 2px;
}
.qr_code_traveller{
  margin-left: 22px;
}
.qr_detail{
  margin-bottom: 5px;
}
.qr_detail_list{
  margin-top: 20px;
}
.xs-qrcode-produce{
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ED7457;
}
.refund-notice{
  font-size: 13px;
  color: @font-red;
  text-align: center;
  margin-top: 10px;
}
.toggle-info{
  margin-top: 15px;
}
.toggle{
   cursor:pointer;
}
.displayName{
  font-size: 16px;
  width: 80%;
}
.wait-ticket{
  width: 55px;
  color:#99359f;
  padding:2px 8px;
  border:1px solid #99359f;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.not-active{
  width: 55px;
  color:#b8862d;
  padding:2px 8px;
  border:1px solid #b8862d;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.unused{
  width: 55px;
  color:#109863;
  padding:2px 8px;
  border:1px solid #109863;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.part-used{
  width: 55px;
  color:#e9663e;
  padding:2px 8px;
  border:1px solid #e9663e;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.already-used{
  width: 55px;
  color:#e9663e;
  padding:2px 8px;
  border:1px solid #e9663e;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.refunded{
  width: 55px;
  color:#df4747;
  padding:2px 8px;
  border:1px solid #df4747;
  border-radius:15px;
  font-size:10px;
  height: 24px;
}
.waiting{
  color:#b753a3
}
.already{
  color:#32c99d
}
.completed{
  color: #fcc03f
}
.cancelled{
  color:#41a4c9
}
.closed{
  color:#ed7f65
}
.gary{
  color:#999
}
.order-detail-space{
  display:inline-block;
  width:70px
}
.ticket-detail-space{
  display:inline-block;
  width:65px
}
.explain{
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
}
.explain-notice{
  font-size: 13px;
  color: @font-red;
  text-align: center;
  margin-top: 10px;
}
</style>
